import Cascader from './src/cascader2.mjs';
export { cascaderEmits, cascaderProps } from './src/cascader.mjs';
import './src/instances.mjs';
Cascader.install = app => {
  app.component(Cascader.name, Cascader);
};
const _Cascader = Cascader;
const ElCascader = _Cascader;
export { ElCascader, _Cascader as default };